import module from 'empresa/module.js'
import template from './template.html'

export default class EmpresaCuentasAgregarConfirmacionComponent {
  empresaId
  data
  onClose
  error = false
  resultado = null
  procesando = false

  constructor (EmpresaCuentas) {
    this.EmpresaCuentasService = EmpresaCuentas
  }

  guardar () {
    if (this.procesando) return

    this.procesando = true

    this.EmpresaCuentasService.post(this.empresaId, this.data)
      .then(({data}) => (this.resultado = data))
      .catch(({data}) => (this.error = data))
      .finally(() => (this.procesando = false))
  }

  cerrar () {
    this.onClose({$event: {detail: this.resultado}})
  }
}

module.component('empresaCuentasAgregarConfirmacion', {
  controller: EmpresaCuentasAgregarConfirmacionComponent,
  template,
  bindings: {
    empresaId: '<',
    data: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/cuentas/agregar/confirmacion/component.js